export default __webpack_public_path__ + "assets/images/4898323e9ac1a6e7007f0b4fb25ce046.png";